import { Paper } from "@mui/material";
import PairAddRecordsFilter from "./PairAddRecordsFilter";
import PairAddRecordsTable from "./PairAddRecordsTable";
import { useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { setNormalizedFinancialMonthlyEarningsData } from "../../../../../../../features/financeReceiptSlice";

const tableHeadings = {
  id: "FME",
  month: "Date",
  invoice_total_income: "Invoice Total Income",
  manual_invoice_total_income: "Manual FME Income",
  linked: "Linked",
  fme_status: "FME Status",
  account: "Account",
  brands: "Brands",
};

const FME_STATUS_MAP: Record<number, string> = {
  1: "Initial",
  2: "Pending Approval",
  3: "Approved for Invoice",
  4: "Invoice Generated",
  5: "Invoice Collected",
  6: "Dispute",
  7: "Invoice Not Required",
  8: "Partially Collected",
  9: "Reported as Collected",
  10: "Bad Debts",
};

const PairAddRecords = () => {
  const {
    financialMonthlyEarningsData,
    normalizedFinancialMonthlyEarningsData,
  } = useSelector((state: any) => state.receipts);
  const dispatch = useDispatch();
  const normalizedRows = useMemo(() => {
    return (financialMonthlyEarningsData || []).map((row: any) => ({
      ...row,
      linked:
        Array.isArray(row.receipts_to_fme_uids) &&
        row.receipts_to_fme_uids.length > 0
          ? "Yes"
          : "No",

      fme_status: FME_STATUS_MAP[row.status_id]?.toLowerCase() ?? "initial",

      brands: row.brand_names
        ? row.brand_names.split(",").map((b: string) => b.trim())
        : [],

      account: "",
    }));
  }, [financialMonthlyEarningsData]);

  useEffect(() => {
    dispatch(setNormalizedFinancialMonthlyEarningsData(normalizedRows));
  }, [normalizedRows, dispatch]);

  return (
    <>
      <Paper sx={{ mt: 1 }}>
        <div style={{ marginLeft: 15, paddingTop: 10 }}>Browse FME Records</div>
        <PairAddRecordsFilter />
        <PairAddRecordsTable
          tableHeadings={tableHeadings}
          rows={normalizedFinancialMonthlyEarningsData}
        />
      </Paper>
    </>
  );
};

export default PairAddRecords;
